import { Modals } from '../state';
import { patch } from './patch';

export const setModal = (modal: Modals) => patch({
  modal
});

export const closeModal = () => patch({ modal: null });
